import Vue from 'vue'
import Router from 'vue-router'
import ProgressBar from '~/components/progress-bar.vue'
import cookie from '~/utils/cookie'
// import { role } from '~/utils/cadre.config'

// 全局进度条
const bar = Vue.prototype.$bar = new Vue(ProgressBar).$mount()
document.body.appendChild(bar.$el)

Vue.use(Router)

const routes = [
  {
    path: '/404',
    component: () => import('../views/404.vue')
  },
  {
    path: '*',
    redirect: '/404'
  },
  // 首页
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    component: () => import('../views/login')
  },
  {
    // 首页
    path: '/home',
    component: () => import('../views/home'),
    // 判断是否有token
    beforeEnter: (to, from, next) => {
      let token = cookie.get('token')
      if (token) {
        next()
      } else {
        next('/login')
      }
    },
    children: [
      {
        // 超级管理员默认页面 管理账号
        path: 'superAdmin',
        component: () => import('../views/home/superAdmin/index.vue'),
        meta: {
          rouls: ['super_supervisor']
        }
      },
      {
        // 用户管理
        path: 'common/userAdmin',
        component: () => import('../views/home/common/userAdmin/index.vue'),
        meta: {
          rouls: ['project_supervisor', 'center_supervisor']
        }
      },
      {
        // 用户详情
        path: 'common/userAdmin/detail/:id',
        component: () => import('../views/home/common/userAdmin/details.vue'),
        meta: {
          rouls: ['project_supervisor', 'center_supervisor']
        }
      },
      {
        // 方案管理
        path: 'common/schemeAdmin',
        component: () => import('../views/home/common/schemeAdmin/index.vue'),
        meta: {
          rouls: ['project_supervisor', 'center_supervisor']
        }
      },
      {
        // 方案详情
        path: 'common/schemeAdmin/detail/:id',
        component: () => import('../views/home/common/schemeAdmin/details.vue'),
        meta: {
          rouls: ['project_supervisor', 'center_supervisor']
        }
      },
      {
        // 项目主管默认页面 待处理方案
        path: 'steward',
        component: () => import('../views/home/steward/index.vue'),
        meta: {
          rouls: ['project_supervisor']
        }
      },
      {
        // 中心主任 默认页面 待认证用户
        path: 'director',
        component: () => import('../views/home/director/index.vue'),
        meta: {
          rouls: ['center_supervisor']
        }
      },
      {
        // 中心主任 课程管理 [课程列表]
        path: 'director/coursesAdmin',
        component: () => import('../views/home/director/coursesAdmin/index.vue'),
        meta: {
          rouls: ['center_supervisor']
        }
      },
      {
        // 中心主任 课程管理 [课程详情 || 添加课程]
        path: 'director/coursesAdmin/details/:type',
        component: () => import('../views/home/director/coursesAdmin/details.vue'),
        meta: {
          rouls: ['center_supervisor']
        }
      },
      {
        // 中心主任 教师管理 [教师列表]
        path: 'director/teachersAdmin',
        component: () => import('../views/home/director/teachersAdmin/index.vue'),
        meta: {
          rouls: ['center_supervisor']
        }
      },
      {
        // 中心主任 教师管理 [教师详情 || 添加教师]
        path: 'director/teachersAdmin/details/:type',
        component: () => import('../views/home/director/teachersAdmin/details.vue'),
        meta: {
          rouls: ['center_supervisor']
        }
      },
      {
        // 中心主任 价格设置
        path: 'director/baseSetting/price',
        component: () => import('../views/home/director/baseSetting/price.vue'),
        meta: {
          rouls: ['center_supervisor']
        }
      },
      {
        // 中心主任 酒店列表
        path: 'director/baseSetting/hotelAdmin',
        component: () => import('../views/home/director/baseSetting/hotel/index.vue'),
        meta: {
          rouls: ['center_supervisor']
        }
      },
      {
        // 中心主任 酒店详情
        path: 'director/baseSetting/hotelAdmin/details/:type',
        component: () => import('../views/home/director/baseSetting/hotel/details.vue'),
        meta: {
          rouls: ['center_supervisor']
        }
      }
    ]
  }
]

const router = new Router({
  mode: 'history',
  routes,
  linkActiveClass: 'link-active',
  scrollBehavior (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})
/*
  ['project_supervisor'],
  ['center_supervisor'],
  'super_supervisor'
*/
router.beforeEach(async (to, from, next) => {
  bar.start()
  if (localStorage.getItem('userInfo')) {
    let role = JSON.parse(localStorage.getItem('userInfo')).role
    if (to.meta.rouls) {
      if (to.meta.rouls.includes(role)) {
        next()
      } else {
        next('/404')
      }
    } else {
      next()
    }
  } else {
    if (to.path === '/login') {
      next()
    } else {
      next('/login')
    }
    // next()
  }
  // console.log(to)
  // console.log('最终')
  // next()
})

router.afterEach((to, from) => {
  bar.finish()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js